import * as React from 'react';
import { UitkNewDatePicker, UitkNewDatePickerTriggeredSelector } from 'uitk-react-new-date-picker';
import { LocalizedComponentClass, LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { observer } from 'mobx-react';
import { QueryRoute } from 'bernie-core';
import { Layer } from 'bernie-view';

export interface NewDatePickerProps extends LocalizedComponentProps {
  endDate: string;
  startDate: string;
  isOpen: boolean;
  onOpen: (dateType: UitkNewDatePickerTriggeredSelector) => void;
  onDismiss: (isMobile: boolean, noUpdate: boolean) => void;
  onSubmit: (startDate: Date, endDate: Date) => void;
}

const NewDatePickerComponent = observer((props: NewDatePickerProps) => {
  const checkInDatePlaceholder = '';
  const checkOutDatePlaceholder = '';
  const routerLinkWrapper = (children) => <>{children}</>;

  const dialogWrapper = (children, dateType) => (
    <QueryRoute query={{ pwaDialog: `datepicker-${dateType}` }}>
      <Layer id={`home-datepicker-${dateType}`} onDismiss={props.onDismiss}>
        {children}
      </Layer>
    </QueryRoute>
  );
  const dateFieldProps = {
    startId: UitkNewDatePickerTriggeredSelector.START,
    startLabel: 'Check In',
    startPlaceholder: checkInDatePlaceholder,
    endId: UitkNewDatePickerTriggeredSelector.END,
    endLabel: 'Check Out',
    endPlaceholder: checkOutDatePlaceholder,
    showDatePicker: props.isOpen,
    onChange: () => {
      // TODO: this is followed-up by flight pwa team with uitk-react team
    },
    dateFieldWrapperClasses: 'uitk-grid uitk-cell s-cell-1-1 m-cell-1-3 l-cell-1-6 xl-cell-1-6',
    routerLinkWrapper,
    dialogWrapper,
  };

  return (
    <UitkNewDatePicker
      doubleMonths={true}
      dateFieldProps={dateFieldProps}
      onOpenCB={props.onOpen}
      onDismissCB={props.onDismiss}
      onSubmitCB={props.onSubmit}
      buttonText="Done"
      startDate={props.startDate}
    />
  );
});

export const NewDatePicker: LocalizedComponentClass<NewDatePickerProps> = withLocalization(NewDatePickerComponent);
